import { skills } from '../data/skills';

export const getSkills = () => skills;

export const getSkill = (id) =>
  skills.find(skill => skill.id === id);